import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios, { AxiosError } from "axios";

export const fetchLatestUploadImageData = createAsyncThunk(
  "latestuploadimage",
  async (formData: FormData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_NEW_API_URL}/latestuploadimage`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${import.meta.env.VITE_API_KEY}`,
          },
        },
      );
      const customerArtList = await Promise.all(
         response.data?.latestimages.map(async (item: any) => {
          item.convert_image = await convertImageUrlToBase64(item.convert_image);
          // item.convert_image = await convertImageUrlToBase64(`https://dummyimage.com/600x400/000/fff`);
          return item;
        })
      );

      return customerArtList;
      // return response.data?.latestimages;
    } catch (error) {
      throw rejectWithValue((error as AxiosError)?.response?.data);
    }
  },
);

export const fetchAllCusotmerArtData = createAsyncThunk(
  "getAllCusotmerArt",
  async (formData: FormData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_NEW_API_URL}/getAllCusotmerArt`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${import.meta.env.VITE_API_KEY}`,
          },
        },
      );
      const customerArtList = await Promise.all(
        response.data?.customer_art.map(async (item: any) => {
          item.convert_image = await convertImageUrlToBase64(item.convert_image);
          // item.convert_image = await convertImageUrlToBase64(`https://dummyimage.com/600x400/000/fff`);
          return item;
        })
      );

      return customerArtList;

      // return response.data?.customer_art;
    } catch (error) {
      throw rejectWithValue((error as AxiosError)?.response?.data);
    }
  },
);

export const deleteArtData = createAsyncThunk(
  "getRemoveArtData",
  async (formData: FormData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_API_URL}/getRemoveArtData`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${import.meta.env.VITE_API_KEY}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      throw rejectWithValue((error as AxiosError)?.response?.data);
    }
  },
);

export const getCustomerArtData = createAsyncThunk(
  "GetCustomerArtData",
  async (formData: FormData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_NEW_API_URL}/GetCustomerArtData`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${import.meta.env.VITE_API_KEY}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      throw rejectWithValue((error as AxiosError)?.response?.data);
    }
  },
);

interface UploadedArtState {
  latestUploadImageLoading: boolean;
  cusotmerArtLoading: boolean;
  deleteArtDataLoading: boolean;
  latestUploadedImageData: any;
  allCusotmerArtData: any;
  error: string;
}

const initialState: UploadedArtState = {
  latestUploadImageLoading: false,
  cusotmerArtLoading: false,
  deleteArtDataLoading: false,
  latestUploadedImageData: null,
  allCusotmerArtData: null,
  error: "",
};

export const uploadedArtSlice = createSlice({
  name: "uploadedArt",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLatestUploadImageData.pending, (state) => {
        state.latestUploadImageLoading = true;
        state.error = "";
      })
      .addCase(fetchLatestUploadImageData.fulfilled, (state, action) => {
        state.latestUploadImageLoading = false;
        state.latestUploadedImageData = action.payload;
        state.error = "";
      })
      .addCase(fetchLatestUploadImageData.rejected, (state, action) => {
        state.latestUploadImageLoading = false;
        state.latestUploadedImageData = null;
        state.error =
          action.error.message || "Failed to fetch customer art data";
      });
    builder
      .addCase(fetchAllCusotmerArtData.pending, (state) => {
        state.cusotmerArtLoading = true;
        state.error = "";
      })
      .addCase(fetchAllCusotmerArtData.fulfilled, (state, action) => {
        state.cusotmerArtLoading = false;
        state.allCusotmerArtData = action.payload;
        state.error = "";
      })
      .addCase(fetchAllCusotmerArtData.rejected, (state, action) => {
        state.cusotmerArtLoading = false;
        state.allCusotmerArtData = null;
        state.error =
          action.error.message || "Failed to fetch customer art data";
      });
    builder
      .addCase(deleteArtData.pending, (state) => {
        state.deleteArtDataLoading = true;
        state.error = "";
      })
      .addCase(deleteArtData.fulfilled, (state) => {
        state.deleteArtDataLoading = false;
        state.error = "";
      })
      .addCase(deleteArtData.rejected, (state, action) => {
        state.deleteArtDataLoading = false;
        state.error = action.error.message || "Failed to delete art data";
      });
  },
});

const getMimeTypeFromUrl = (url: string): string => {
  if (url.endsWith(".png")) return "image/png";
  if (url.endsWith(".jpg") || url.endsWith(".jpeg")) return "image/jpeg";
  if (url.endsWith(".gif")) return "image/gif";
  return "application/octet-stream";
};

const convertImageUrlToBase64 = async (url: string): Promise<string | null> => {
  try {
    const response = await fetch(url);
    const buffer = await response.arrayBuffer();

    const mimeType = getMimeTypeFromUrl(url);

    const blob = new Blob([buffer], { type: mimeType });

    return await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};

export default uploadedArtSlice.reducer;
